import { controls,grouped } from "../controls";
const rerun_cf_ac_validations = {
label: "Rerun Cf Ac Validations",
pageLabel: "Rerun Cf Ac Validations",starting: true,url: "autogen",
formActions: { edit: { allow: true },delete:{allow:false} },
pageType: "history",
filter:[
]
,form:[
...controls.displayText({ tab: "general", label: "Taluka",star:false}),
...controls.oc({ tab: "general", c: "Taluka", placeHolder: "Taluka Code", name: "taluka_code",fastpath: "talukas" ,isReadOnly:"edit" ,hidden:false}),
...controls.showData({ tab: "general", displaytype: "capital", data: "taluka_display"}),
...controls.displayText({ tab: "general", label: "Village",star:false}),
...controls.oc({ tab: "general", c: "Village", placeHolder: "Village Code", name: "village_code",fastpath: "villages" ,isReadOnly:"edit" ,hidden:false}),
...controls.showData({ tab: "general", displaytype: "capital", data: "village_display"}),
]
,history:{
perPage: 10,
reportHeader: "Rerun Cf Ac Validations",
pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
clickable: true,
displayColumns: [
{Header: "Sr",type: "autoinc",accessor: "srno",align: "center",width: 30},
{Header: "Taluka",accessor: "RerunCFACValidation-taluka-taluka_display",},
{Header: "Createdat",accessor: "createdat",type:'date'},
{Header: "Last Transaction Position",accessor: "last_transaction_position",},
{Header: "Checked",accessor: "checked",},
{Header: "Corrected",accessor: "corrected",},
]}};
export default rerun_cf_ac_validations;